export const journeyType = {
  INDIVIDUAL: 1,
  COMPANY: 2,
  GROUP: 3,
}

export const commonConst = {
  abroadPlaceholderImage: 'abroad-gold.png',
}
